document
    .querySelectorAll('[data-menu-toggle]')
    .forEach((el) => {
        el.addEventListener('click', () => {

            const
                containerSelector = el.dataset.menuToggle,
                container = document.querySelector(containerSelector);

            if (!container)
                throw new Error(`Can't find '${containerSelector}' selector`);

            container.classList.toggle('mobile:!header-menu--open');
            container.classList.add('!visible');

            // eslint-disable-next-line no-unused-expressions
            container.classList.contains('mobile:!header-menu--open')
                ? document.body.classList.add('no-scroll')
                : document.body.classList.remove('no-scroll');

        });
    });